import styled from "styled-components";

export const Breadcrumbs = styled.div`
  margin: 1rem 0;
`;
